module.exports = {
  stringToUrl: str =>
    str
      .replace(new RegExp(/\W/, 'g'), '-')
      .replace(new RegExp(/-{2,}/, 'g'), '-')
      .replace(new RegExp(/-$/, 'g'), '')
      .toLowerCase(),
  stringToVocabularyUrl: str =>
    'pmp-vocabulary-' +
    str
      .replace(new RegExp(/\W/, 'g'), '-')
      .replace(new RegExp(/-{2,}/, 'g'), '-')
      .replace(new RegExp(/-$/, 'g'), '')
      .toLowerCase()
}
